import { render, staticRenderFns } from "./address1.vue?vue&type=template&id=199a1945&scoped=true&"
import script from "./address1.vue?vue&type=script&lang=js&"
export * from "./address1.vue?vue&type=script&lang=js&"
import style0 from "./address1.vue?vue&type=style&index=0&id=199a1945&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a1945",
  null
  
)

export default component.exports